webpackJsonp([60168589576476],{

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/sheshines/19june2025/1.jpg";
	var I2 = "https://www.winpeforum.com/assets/sheshines/19june2025/2.jpg";
	var I3 = "https://www.winpeforum.com/assets/sheshines/19june2025/3.jpg";
	var I4 = "https://www.winpeforum.com/assets/sheshines/19june2025/4.jpg";
	var I5 = "https://www.winpeforum.com/assets/sheshines/19june2025/5.jpg";
	var I6 = "https://www.winpeforum.com/assets/sheshines/19june2025/6.jpg";
	var I7 = "https://www.winpeforum.com/assets/sheshines/19june2025/7.jpg";
	var I8 = "https://www.winpeforum.com/assets/sheshines/19june2025/8.jpg";
	var I9 = "https://www.winpeforum.com/assets/sheshines/19june2025/9.jpg";
	var I10 = "https://www.winpeforum.com/assets/sheshines/19june2025/10.jpg";
	var I11 = "https://www.winpeforum.com/assets/sheshines/19june2025/11.jpg";
	var I12 = "https://www.winpeforum.com/assets/sheshines/19june2025/12.jpg";
	var I13 = "https://www.winpeforum.com/assets/sheshines/19june2025/13.jpg";
	var I14 = "https://www.winpeforum.com/assets/sheshines/19june2025/14.jpg";
	var I15 = "https://www.winpeforum.com/assets/sheshines/19june2025/15.jpg";
	var I16 = "https://www.winpeforum.com/assets/sheshines/19june2025/16.jpg";
	var I17 = "https://www.winpeforum.com/assets/sheshines/19june2025/17.jpg";
	var I18 = "https://www.winpeforum.com/assets/sheshines/19june2025/18.jpg";
	var I19 = "https://www.winpeforum.com/assets/sheshines/19june2025/19.jpg";
	var I20 = "https://www.winpeforum.com/assets/sheshines/19june2025/20.jpg";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/1.jpg";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/2.jpg";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/3.jpg";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/4.jpg";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/5.jpg";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/6.jpg";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/7.jpg";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/8.jpg";
	var II9 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/9.jpg";
	var II10 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/10.jpg";
	var II11 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/11.jpg";
	var II12 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/12.jpg";
	var II13 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/13.jpg";
	var II14 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/14.jpg";
	var II15 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/15.jpg";
	var II16 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/16.jpg";
	var II17 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/17.jpg";
	var II18 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/18.jpg";
	var II19 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/19.jpg";
	var II20 = "https://www.winpeforum.com/download.php?file=assets/sheshines/19june2025/20.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.CollegiumsImages = [{ id: 1, ImgSrc: I1, ImgSrc1: II1 }, { id: 1, ImgSrc: I2, ImgSrc1: II2 }, { id: 2, ImgSrc: I3, ImgSrc1: II3 }, { id: 3, ImgSrc: I4, ImgSrc1: II4 }, { id: 4, ImgSrc: I5, ImgSrc1: II5 }, { id: 5, ImgSrc: I6, ImgSrc1: II6 }, { id: 6, ImgSrc: I7, ImgSrc1: II7 }, { id: 7, ImgSrc: I8, ImgSrc1: II8 }, { id: 8, ImgSrc: I9, ImgSrc1: II9 }, { id: 9, ImgSrc: I10, ImgSrc1: II10 }, { id: 10, ImgSrc: I11, ImgSrc1: II11 }, { id: 11, ImgSrc: I12, ImgSrc1: II12 }, { id: 12, ImgSrc: I13, ImgSrc1: II13 }, { id: 13, ImgSrc: I14, ImgSrc1: II14 }, { id: 13, ImgSrc: I15, ImgSrc1: II15 }, { id: 13, ImgSrc: I16, ImgSrc1: II16 }, { id: 13, ImgSrc: I17, ImgSrc1: II17 }, { id: 13, ImgSrc: I18, ImgSrc1: II18 }, { id: 13, ImgSrc: I19, ImgSrc1: II19 }, { id: 13, ImgSrc: I20, ImgSrc1: II20 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "sheshines with Winpe",
	        image: "https://winpeforum.com/assets/elements/sheshineswebpage1.png",
	        description: "Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Heading2.default, { title: "sheshines with Winpe Image Gallery" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                this.CollegiumsImages.map(function (item, j) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-4 col-sm-6 col-xs-12", style: { padding: '8px' } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img_card" },
	                      _react2.default.createElement("img", { style: { width: '100%' }, src: item.ImgSrc, alt: "Winpe sheshines" }),
	                      _react2.default.createElement(
	                        "a",
	                        { href: item.ImgSrc1 },
	                        " ",
	                        _react2.default.createElement("i", { style: { color: 'white', position: 'absolute', left: '330px', top: '20px' }, "class": "fa fa-2x  fa-download " })
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sheshines-19-june-2025-gallery-js-4e100d54189676cde694.js